export default __webpack_public_path__ + "static/media/11132.42a08ef1.jpg";